export default __webpack_public_path__ + "assets/images/7d5f9373ae59d29f2f4a65c14991f599.svg";